import { postMutation } from '@/lib/react-query/mutate';
import { markLoginPending } from '@/lib/posthog/login';

import type { SAMLResponse } from '../types';

export const useSamlStart = () =>
  postMutation<SAMLResponse>({
    endpoint: 'auth/saml/start',
    mutationOptions: {
      onSuccess: (data) => {
        // Nothing on the way back says the session came from a login.
        markLoginPending();
        window.location.assign(data.redirect_url);
      },
      meta: {
        avoidAuthRedirection: true,
      },
    },
  });
